// ─── Estilos base del PDF ─────────────────────────────────────────────────────
export const stylesPdf = {
  mainTitle: {
    fontSize: 14,
    bold: true,
    color: "#111111",
    margin: [0, 0, 0, 2],
  },
  formId: {
    fontSize: 11,
    bold: true,
    color: "#ED9519",
    characterSpacing: 0.5,
  },
  formDate: {
    fontSize: 8,
    color: "#888888",
    margin: [0, 2, 0, 0],
  },
  subheader2: {
    fontSize: 14,
    bold: true,
    color: "#111111",
    margin: [0, 0, 0, 2],
  },
  tableHeader: {
    bold: true,
    fontSize: 8.5,
    color: "#ffffff",
  },
  tableCell: {
    fontSize: 9,
    color: "#333333",
  },
  tableCellAccent: {
    fontSize: 9,
    bold: true,
    color: "#1a0e00",
  },
  disclaimer: {
    fontSize: 7.5,
    color: "#555555",
    italics: true,
  },
  direccion: {
    fontSize: 8,
    color: "#666666",
  },
  imagenLogo: {
    margin: [0, 0, 0, 0],
  },
  fecha: {
    fontSize: 8,
    color: "#888888",
  },
  tableExample: {
    fontSize: 9,
    margin: [0, 4, 0, 4],
  },
  tableExample2: {
    fontSize: 8,
    margin: [0, 4, 0, 10],
  },
};

// ─── Helpers de diseño ────────────────────────────────────────────────────────

/** Título de sección: texto en mayúsculas + línea gris fina debajo */
export const sectionTitle = (text, marginTop = 12) => ({
  stack: [
    {
      text: text.toUpperCase(),
      bold: true,
      fontSize: 8,
      color: "#111111",
      characterSpacing: 0.8,
      margin: [0, 0, 0, 3],
    },
    {
      canvas: [{
        type: "line", x1: 0, y1: 0, x2: 515, y2: 0,
        lineWidth: 0.5, lineColor: "#dddddd",
      }],
    },
  ],
  margin: [0, marginTop, 0, 5],
});

/** Celda de cabecera de tabla (fondo negro, texto blanco) */
export const th = (text, options = {}) => ({
  text,
  bold: true,
  fontSize: 8.5,
  color: "#ffffff",
  fillColor: "#111111",
  margin: [5, 4, 5, 4],
  ...options,
});

/** Celda de datos con fila alternada */
export const td = (text, isEven = false, options = {}) => ({
  text: text ?? "—",
  fontSize: 9,
  color: "#333333",
  fillColor: isEven ? "#f5f5f5" : "#ffffff",
  margin: [5, 3, 5, 3],
  ...options,
});

/** Celda de datos con acento naranja (tipo servicio, etc.) */
export const tdAccent = (text, isEven = false) => ({
  text: text ?? "—",
  fontSize: 9,
  bold: true,
  color: "#1a0e00",
  fillColor: "#ED9519",
  margin: [5, 3, 5, 3],
});

/** Línea separadora */
export const divider = (marginTop = 4, marginBottom = 8, color = "#111111", lineWidth = 2) => ({
  canvas: [{
    type: "line", x1: 0, y1: 0, x2: 515, y2: 0,
    lineWidth, lineColor: color,
  }],
  margin: [0, marginTop, 0, marginBottom],
});
